globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Emailing = appCustomerSpace.Controllers.Emailing || {};

appCustomerSpace.Controllers.Emailing.CrmListsController = (function (superClass) {

  utils.extend(CrmListsController, superClass);

  function CrmListsController() {
    return CrmListsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(CrmListsController.prototype, {
    init: function () {
      this.$body.on('click', '.remove-contact-button', function(e) {
        var $loaderPlaceHolder = $(e.currentTarget).closest('button');
        appCustomerSpace.Loader().start({$container: $loaderPlaceHolder, options: {text: false, style: {backdrop: { display: 'none'}}}})
        e.preventDefault();
        var $button = $(this);
        var $form = $button.closest('form');
        var $modal = $button.closest('.modal');
        var $modalBody = $modal.find('.modal-body');
        var $modalFooter = $modal.find('.modal-footer');

        $.post($form.attr('action'), $form.serialize(), function(data) {
          if(data.response) {
            let uniq_key = data.contact_uniq_key;
            $(`.tr-contact-${uniq_key}`).remove();
          }
          appCustomerSpace.Loader().stop();
        });
      });
      return CrmListsController.__super__.init.apply(this, arguments);
    },
  });

  return CrmListsController;

})(appCustomerSpace.Controllers.Emailing.MainController);
